import configuratorValuationAdmHtml from './configuratorValuationAdm.html';
import ContraCP from '../contraCp/ContraCP';
import MainShapeType from "../contraCp/types/mainShapeType";
import Validator from './../configurator/validator';

class configuratorValuationAdmController {
    constructor($scope, $timeout, $http, $sce, $location, $q, materialsService, ModalService, translateService) {
        'ngInject';

        this.$scope = $scope;
        this.$timeout = $timeout;
        this.$http = $http;
        this.$sce = $sce;
        this.$location = $location;
        this.$q = $q;
        this.materialsService = materialsService;
        this.modalService = ModalService;
        this.translate = translateService;

        this.valuationId = false;
        this.materials = [];
        this.shops = [];
        this.priceGroups = [];
        this.paymentMethods = [];
        this.templates = [];
        this.sections = [];
        this.sectionsColumns = [];
        this.valuation = {
            id: null,
            number: null,
            shop_id: 1,
            price_group_id: null,
            client_data: null,
            email: null,
            offer_validity: 14,
            created_at: null,
            payments: {},
            template_id: null,
            template_b2b: 0,
            template_options: {},
            user_notified_at: null,
            user_notified_by_admin_id: null,
            user_notified_admin: {},
            hubspot_deal_id: null,
            hubspot_notified_at: null,
            hubspot_notified_by_admin_id: null,
            hubspot_admin: {}
        };
        this.defaultDiscount = 0;
        this.defaultShipmentId = null;
        this.variants = [];
        this.currentDate = new Date();
        this.offerValidityDate = new Date();
        this.message = '';
        this.loading = true;
        this.error = false;
        this.success = false;
        this.settingMainShape = false;
        this.getItemPriceRequests = new Map();
        this.loadTemplatesMethodsRequests = 0;
        this.init = false;
        this.cutModes = {};
        this.loggedAdmin = {};

        this.loadLoggedAdmin();
        this.loadPriceGroups();
        this.loadShops();

        this.$scope.$watch(() => this.valuation, (oldVal, newVal) => {
            if (!oldVal || oldVal.shop_id !== newVal.shop_id) {
                this.setLanguage();
            }
        }, true);
    }

    $onInit() {
        this.cutModes = cutModes;
    }

    loadLoggedAdmin() {
        this.$http.get(
            `/admpanel/ajax/configurator/valuations/getLoggedAdmin`
        ).then(
            (response) => {
                this.loading = false;

                if (response.data.status === 'error') {
                    this.error = response.data.message;

                    this.$timeout(() => {
                        this.error = false;
                    }, 5000);
                } else {
                    this.loggedAdmin = response.data;
                }
            },
            () => {
                alert(this.translate.t('admpanel.general.unexpectedErrorHasOccurred'));
            }
        );
    }

    loadPriceGroups() {
        this.$http.get(
            `/admpanel/ajax/configurator/valuations/getPriceGroups`
        ).then(
            (response) => {
                this.loading = false;

                if (response.data.status === 'error') {
                    this.error = response.data.message;

                    this.$timeout(() => {
                        this.error = false;
                    }, 5000);
                } else {
                    this.priceGroups = [];
                    for (let key in response.data) {
                        this.priceGroups.push({
                            id: response.data[key].id,
                            name: response.data[key].name,
                            surcharge_waste: response.data[key].surcharge_waste
                        });
                    }
                }
            },
            () => {
                alert(this.translate.t('admpanel.general.unexpectedErrorHasOccurred'));
            }
        );
    }

    loadShops() {
        this.$http.get(
            `/admpanel/ajax/configurator/valuations/getShops`
        ).then(
            (response) => {
                this.loading = false;

                if (response.data.status === 'error') {
                    this.error = response.data.message;

                    this.$timeout(() => {
                        this.error = false;
                    }, 5000);
                } else {
                    this.shops = [];
                    for (let key in response.data) {
                        this.shops.push({
                            id: response.data[key].id,
                            name: response.data[key].name,
                            locale: response.data[key].locale,
                            currency: response.data[key].currency,
                            templates_status: response.data[key].templates_status,
                            price_group_id: response.data[key].price_group_id,
                            surcharge_waste: response.data[key].surcharge_waste
                        });
                    }

                    this.setPriceGroup(true);

                    for (let variant of this.variants) {
                        variant.surcharge_waste = this.shops[this.valuation.shop_id].surcharge_waste;
                    }

                    this.loadMaterials();
                }
            },
            () => {
                alert(this.translate.t('admpanel.general.unexpectedErrorHasOccurred'));
            }
        );
    }

    loadMaterials() {
        this.materialsService.getMaterials().then((response) => {
            for (let material of response.data) {
                material.available = true;
                if (material.image !== null) {
                    material.image = material.image.src || null;
                } else {
                    material.image = null;
                }
            }

            this.materials = response.data;

            this.$scope.$watch(() => this.valuationId, (newVal, oldVal) => {
                if (newVal === null) {
                    this.$timeout(() => {
                        this.loading = false;
                    }, 500);

                    return;
                }

                if (typeof newVal === 'undefined') {
                    this.valuationId = null;
                    this.loadPaymentMethods();
                    this.loadTemplates();
                    Validator.setMaterialsMaxDimensions(this.materials);
                } else if (oldVal !== newVal || this.init === false) {
                    this.init = true;
                    this.loadValuation().then(() => {
                        this.loadVariants();
                        if (this.valuation.email) {
                            this.loadUserDiscount(false).then((discount) => {
                                this.defaultDiscount = parseInt(discount);
                            });
                        }
                    });
                }
            });
        });
    }

    loadPaymentMethods() {
        console.log('% loadPaymentMethods()');

        if (this.valuation.shop_id === null) {
            return;
        }

        this.$http.get(
            `/admpanel/ajax/configurator/valuations/getPaymentMethods/${this.valuation.shop_id}`
        ).then(
            (response) => {
                this.loading = false;

                if (response.data.status === 'error') {
                    this.error = response.data.message;

                    this.$timeout(() => {
                        this.error = false;
                    }, 5000);
                } else {
                    this.paymentMethods = [];
                    for (let key in response.data) {
                        this.paymentMethods.push({
                            id: parseInt(key),
                            label: response.data[key].name,
                            hidden: response.data[key].hidden
                        });
                    }
                }
            },
            () => {
                alert(this.translate.t('admpanel.general.unexpectedErrorHasOccurred'));
            }
        );
    }

    loadShipmentMethods(variant) {
        console.log('% loadShipmentMethods()');

        const deferred = this.$q.defer();
        variant.loadShipmentMethodsRequests++;

        this.$http.get(
            `/admpanel/ajax/configurator/valuations/getShipmentMethods/${this.valuation.shop_id}/${this.valuation.id}/${variant.id}`
        ).then(
            (response) => {
                this.loading = false;
                variant.loadShipmentMethodsRequests--;

                if (response.data.status === 'error') {
                    this.error = response.data.message;

                    this.$timeout(() => {
                        this.error = false;
                    }, 5000);
                } else {
                    variant.shipmentMethods = [];
                    for (let key in response.data) {
                        variant.shipmentMethods.push(response.data[key]);
                    }

                    // Sprawdzamy, czy zapisana metoda wysyłki jest możliwa do wybrania
                    if (variant.shipment_id) {
                        if (!variant.shipmentMethods.find(shipmentMethod => shipmentMethod.id === variant.shipment_id)) {
                            console.log(`% Selected shipment id = ${variant.shipment_id} does not exists, set default method`);
                            variant.shipment_id = null;
                        }
                        if (variant.shipmentAutoSet === true) {
                            variant.shipment_id = null;
                        }
                    }

                    angular.forEach(variant.shipmentMethods, (value, key) => {
                        if (variant.shipment_id === null && value.cheapest) {
                            variant.shipment_id = parseInt(value.id);
                            variant.shipmentAutoSet = true;
                        }
                    });

                    deferred.resolve(variant.shipmentMethods);
                }
            },
            () => {
                alert(this.translate.t('admpanel.general.unexpectedErrorHasOccurred'));
            }
        );

        return deferred.promise;
    }

    loadTemplates() {
        if (!this.getTemplatesStatus()) {
            console.log('% noLoadTemplates()');

            return;
        }

        console.log('% loadTemplates()');

        if (this.valuation.shop_id === null) {
            return;
        }

        this.loadTemplatesMethodsRequests++;

        this.$http.get(
            `/admpanel/ajax/configurator/valuations/templates/getAll/${this.valuation.shop_id}`
        ).then(
            (response) => {
                this.loading = false;
                this.loadTemplatesMethodsRequests--;

                if (response.data.status === 'error') {
                    this.error = response.data.message;

                    this.$timeout(() => {
                        this.error = false;
                    }, 5000);
                } else {
                    this.templates = [];
                    for (let key in response.data.templates) {
                        this.templates.push(response.data.templates[key]);
                    }

                    this.sections = response.data.sections;
                    for (let index in this.sections) {
                        this.sectionsColumns[index] = Math.ceil(this.sections[index].length / 10);
                    }
                }
            },
            () => {
                alert(this.translate.t('admpanel.general.unexpectedErrorHasOccurred'));
            }
        );
    }

    loadValuation() {
        console.log('% loadValuation()');

        const deferred = this.$q.defer();

        this.$http.get(
            `/admpanel/ajax/configurator/valuations/getValuation/${this.valuationId}`
        ).then(
            (response) => {
                this.loading = false;

                if (response.data.status === 'error') {
                    this.error = response.data.message;

                    this.$timeout(() => {
                        this.error = false;
                    }, 5000);
                } else {
                    this.valuation = response.data.valuation;

                    this.setCurrentDate();

                    this.setLanguage();

                    this.loadPaymentMethods();

                    this.loadTemplates();

                    Validator.setMaterialsMaxDimensions(this.materials, this.valuation.shop_id);

                    deferred.resolve(this.valuation);
                }
            },
            () => {
                alert(this.translate.t('admpanel.general.unexpectedErrorHasOccurred'));
            }
        );

        return deferred.promise;
    }

    loadVariants() {
        console.log('% loadVariants()');

        this.$http.get(
            `/admpanel/ajax/configurator/valuations/getVariants/${this.valuationId}`
        ).then(
            (response) => {
                this.loading = false;

                if (response.data.status === 'error') {
                    this.error = response.data.message;

                    this.$timeout(() => {
                        this.error = false;
                    }, 5000);
                } else {
                    this.variants = response.data.variants;

                    this.variants.sort((variantA, variantB) => {
                        if (parseInt(variantA.sort) > parseInt(variantB.sort)) {
                            return 1;
                        } else if (parseInt(variantA.sort) < parseInt(variantB.sort)) {
                            return -1;
                        } else {
                            return parseInt(variantA.id) - parseInt(variantB.id);
                        }
                    });

                    for (let variant of this.variants) {
                        variant.items_loaded = false;
                        variant.loadShipmentMethodsRequests = 0;
                        variant.shipmentMethods = [];
                        this.watchVariantChanges(variant);
                        this.loadShipmentMethods(variant);
                        this.defaultShipmentId = variant.shipment_id;
                    }

                    this.setPriceGroup(false);

                    this.setSurchargeWaste(false);

                    if (this.variants.length > 0) {
                        this.variants[0].tab_visibility = true;

                        let firstVariantId = this.variants[Object.keys(this.variants)[0]].id;
                        console.log('% loadVariants() - firstVariantId - ' + firstVariantId);

                        this.loadItems(firstVariantId);
                    }
                }
            },
            () => {
                alert(this.translate.t('admpanel.general.unexpectedErrorHasOccurred'));
            }
        );
    }

    loadItems(variantId) {
        console.log('% loadItems() - variantId - ' + variantId);

        if (!variantId) {
            return;
        }

        const variantIndex = this.variants.findIndex(x => x.id === variantId);

        console.log('% loadItems() - variantIndex - ' + variantIndex);

        this.$http.get(
            `/admpanel/ajax/configurator/valuations/getItems/${this.valuationId}/${variantId}`
        ).then(
            (response) => {
                this.loading = false;

                if (response.data.status === 'error') {
                    this.error = response.data.message;

                    this.$timeout(() => {
                        this.error = false;
                    }, 5000);
                } else {
                    this.variants[variantIndex].items = response.data.items;
                    this.variants[variantIndex].items_loaded = true;

                    this.setItemsPreviewContainerId(this.variants[variantIndex].items);
                    this.setItemsMaterials(this.variants[variantIndex].items);
                    this.setItemsOrder(this.variants[variantIndex].items);

                    this.$timeout(() => {
                        for (let item of this.variants[variantIndex].items) {
                            item.saved = true;
                            this.setItemMainShape(item);
                            this.watchItemChanges(item);
                        }
                    }, 300);
                }
            },
            () => {
                alert(this.translate.t('admpanel.general.unexpectedErrorHasOccurred'));
            }
        );
    }

    setLanguage() {
        const shop = this.shops.find(shop => shop.id === this.valuation.shop_id);
        if (!shop) {
            return false;
        }

        this.translate.setCurrentLang(shop.locale, true);

        return true;
    }

    setPriceGroup(force) {
        if (this.valuation.price_group_id === null || force === true) {
            this.valuation.price_group_id = this.shops.find(x => x.id === this.valuation.shop_id).price_group_id;
        }
    }

    setSurchargeWaste(force) {
        for (let variant of this.variants) {
            if (variant.surcharge_waste === null || force === true) {
                variant.surcharge_waste = this.shops.find(x => x.id === this.valuation.shop_id).surcharge_waste;

                this.getItemsPrices(variant.id);
                this.saveVariant(variant);
            }
        }
    }

    setItemsPreviewContainerId(items) {
        for (let item of items) {
            this.setItemPreviewContainerId(item);
        }
    }

    setItemPreviewContainerId(item) {
        if (item.type === 1 && !item.previewContainerId) {
            item.previewContainerId = Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5);
        }
    }

    setItemMainShape(item) {
        console.log('% setItemMainShape');

        if (!item) {
            return;
        }

        if (item.type !== 1) {
            return;
        }

        this.settingMainShape = true;

        if (item.CP && item.data && item.data) {
            console.log('% setItemMainShape destroy', item.data);

            if (item.data.mainShape) {
                item.data.mainShape.destroy();
                item.data.mainShape.setActiveDescription(null);
                item.data.mainShape = null;
            }
            angular.element(document).find('#preview-container-' + item.previewContainerId).empty();
        }

        if (!item.shape) {
            this.settingMainShape = false;
            return;
        }

        if (!item.previewContainerId || !document.getElementById('preview-container-' + item.previewContainerId)) {
            this.settingMainShape = false;
            return;
        }

        item.CP = new ContraCP('#preview-container-' + item.previewContainerId, 200, 150, 1, 5);

        let mainShape = null;

        item.size_1 = item.size_1 ? parseInt(item.size_1) : 0;
        item.size_2 = item.size_2 ? parseInt(item.size_2) : 0;
        item.size_3 = item.size_3 ? parseInt(item.size_3) : 0;

        switch (item.shape) {
            case 'Rect':
                mainShape = item.CP.ElementFactory(MainShapeType.Rect, {x: 0, y: 0, w: item.size_1, h: item.size_2});
                mainShape.type = MainShapeType.Rect;
                console.log('% setItemMainShape created', mainShape);
                break;
            case 'RoundedRect':
                mainShape = item.CP.ElementFactory(MainShapeType.RoundedRect, {
                    x: 0,
                    y: 0,
                    w: item.size_1,
                    h: item.size_2,
                    r: item.size_3
                });
                mainShape.type = MainShapeType.RoundedRect;
                break;
            case 'Circle':
                mainShape = item.CP.ElementFactory(MainShapeType.Circle, {x: 0, y: 0, d: item.size_1});
                mainShape.type = MainShapeType.Circle;
                break;
        }

        item.CP.setMainShape(mainShape);
        mainShape.mergePaths(false);
        mainShape.width = mainShape.oryginalBbox.width.toFixed(0);
        mainShape.height = mainShape.oryginalBbox.height.toFixed(0);

        item.data = {
            elements: [],
            mainShape: mainShape,
            cutMode: item.cut_mode,
            name: mainShape.type.name,
        };

        console.log('% setItemMainShape continue', item.data);

        this.setItemDataMaterial(item);

        item.downloadLink = null;

        // let svg = angular.element(document).find('#preview-container-' + item.previewContainerId + ' > svg').html();
        // // Nie da się przez ustawienie angular.element.setAttribute - po element.html() atrybuty nie są aktualizowane
        // svg = svg.replace('<svg ', '<svg xmlns="http://www.w3.org/2000/svg" ');

        item.production_file = item.CP.getSvgSerialized().data;

        this.$timeout(() => {
            const url = item.CP.getBlobUrl();
            item.downloadLink = this.$sce.trustAsResourceUrl(url);
            this.settingMainShape = false;
        }, 500);
    }

    setItemDataMaterial(item) {
        if (!item || !item.data) {
            return;
        }

        let itemMaterial = {
            type: item.activeMaterial
        }

        if (item.activeSubType) {
            itemMaterial.subType = item.activeSubType;
        }

        if (item.activeSize) {
            itemMaterial.size = item.activeSize;
        }

        item.data.material = itemMaterial;

        console.log('% setItemDataMaterial', item);

        // this.getItemPrice(item);
    }

    setItemsMaterials(items) {
        for (let item of items) {
            this.setItemMaterial(item);
        }
    }

    setItemsOrder(items) {
        let lastOrder = 0;
        for (let item of items) {
            if (!item.order) {
                item.order = ++lastOrder;
                this.saveItem(item);
            } else {
                lastOrder = parseInt(item.order);
            }
        }
    }

    setItemMaterial(item) {
        item.cutModeMessageShape = null;
        item.cutModeMessage = null;
        item.dimensionsWidthMessage = null;
        item.dimensionsHeightMessage = null;

        if (item.material_id) {
            item.init_material_id = item.material_id;
            item.init_material_subtype_id = item.material_subtype_id;
            item.init_material_size_id = item.material_size_id;

            const activeMaterialType = this.materials.filter(material => material.id === item.init_material_id);
            if (activeMaterialType.length > 0) {
                this.changeMaterialType(item, activeMaterialType[0]);
            } else {
                this.changeMaterialType(item, this.materials[0]);
            }

            if (item.init_material_subtype_id && item.activeMaterial && item.activeMaterial.items.length > 0) {
                for (const subType of item.activeMaterial.items) {
                    if (subType.id != item.init_material_subtype_id) {
                        continue;
                    }

                    this.changeMaterialSubType(item, subType);

                    if (item.init_material_size_id && item.activeSubType && item.activeSubType.items.length > 0) {
                        for (const size of item.activeSubType.items) {
                            if (size.id != item.init_material_size_id) {
                                continue;
                            }

                            this.changeMaterialSize(item, size);

                            break;
                        }
                    }

                    break;
                }

                return;
            }

            if (item.init_material_size_id && item.activeMaterial && item.activeMaterial.items.length > 0) {
                for (const size of item.activeMaterial.items) {
                    if (size.id != item.init_material_size_id) {
                        continue;
                    }

                    this.changeMaterialSize(item, size);

                    break;
                }
            }
        } else {
            this.changeMaterialType(item, this.materials[0]);
        }
    }

    watchItemChanges(item) {
        this.$scope.$watch(() => [item.shape, item.size_1, item.size_2, item.size_3, item.cut_mode, item.quantity], (newVal, oldVal) => {
            newVal[1] = parseInt(newVal[1]);
            newVal[2] = parseInt(newVal[2]);
            newVal[3] = parseInt(newVal[3]);
            oldVal[1] = parseInt(oldVal[1]);
            oldVal[2] = parseInt(oldVal[2]);
            oldVal[3] = parseInt(oldVal[3]);
            let same = true;
            for (let i in newVal) {
                if (oldVal[i] !== newVal[i]) {
                    same = false;
                }
            }
            if (same) {
                return;
            }

            console.log('% watch #1', oldVal, newVal);

            this.setItemMainShape(item);
        }, true);

        this.$scope.$watch(() => [item.material_id, item.material_subtype_id, item.material_size_id], (newVal, oldVal) => {
            if (newVal === oldVal) {
                return;
            }

            console.log('% watch #2', oldVal, newVal);

            this.setItemDataMaterial(item);
        }, true);

        this.$scope.$watch(() => item.type, () => this.setItemPreviewContainerId(item));

        this.$scope.$watch(() => [item.type, item.shape, item.size_1, item.size_2, item.size_3, item.quantity, item.cut_mode, item.cut_line, item.material_id, item.material_subtype_id, item.material_size_id, item.new_file_name], (newVal, oldVal) => {
            console.log('% watch #3', oldVal, newVal);

            if (newVal === oldVal) {
                return;
            }

            item.saved = false;

            if (item.save_timeout) {
                this.$timeout.cancel(item.save_timeout);
            }

            item.save_timeout = this.$timeout(() => {
                let saveItemPromise = this.saveItem(item);
                if (saveItemPromise) {
                    saveItemPromise.then(() => {
                        let variant = this.variants.find(variant => variant.id === item.configurator_valuation_variant_id);
                        this.loadShipmentMethods(variant);
                    });
                }
            }, 1000);
        }, true);
    }

    changeMaterialType(item, value) {
        item.activeMaterial = value;
        item.activeSubType = null;
        item.activeSize = null;

        if (value.items && value.items.length > 0) {
            if (value.items[0].items && value.items[0].items.length > 0) {
                item.activeSubType = value.items[0];
                item.activeSize = value.items[0].items[0];
            } else {
                item.activeSize = value.items[0];
            }
        }

        item.material_id = item.activeMaterial !== null ? item.activeMaterial.id : null;
        item.material_subtype_id = item.activeSubType !== null ? item.activeSubType.id : null;
        item.material_size_id = item.activeSize !== null ? item.activeSize.id : null;

        this.changeCutMode(item);
    }

    changeMaterialSubType(item, value) {
        item.activeSubType = value;
        item.activeSize = item.activeSubType.items[0];

        item.material_subtype_id = item.activeSubType !== null ? item.activeSubType.id : null;
        item.material_size_id = item.activeSize !== null ? item.activeSize.id : null;

        this.changeCutMode(item);
    }

    changeMaterialSize(item, value) {
        item.activeSize = value;

        item.material_size_id = item.activeSize !== null ? item.activeSize.id : null;
    }

    addNewVariant() {
        console.log('% addNewVariant()');

        let newVariant = {
            id: null,
            configurator_valuation_id: this.valuation.id,
            letter_id: this.getVariantLetterId(this.variants.length),
            sort: 999999,
            items: [],
            items_loaded: true,
            shipment_id: null,
            surcharge_waste: this.priceGroups.find(x => x.id === this.valuation.price_group_id).surcharge_waste,
            discount: this.defaultDiscount,
            loadShipmentMethodsRequests: 0,
            shipmentMethods: [],
            tab_visibility: true,
            saved: false
        };

        this.variants.push(newVariant);
        this.watchVariantChanges(newVariant);

        this.saveVariant(newVariant).then(() => {
            this.loadShipmentMethods(newVariant);
        });
    }

    cloneVariant(variantId) {
        console.log('% cloneVariant() - variantId: ' + variantId);

        const variantIndex = this.variants.findIndex(x => x.id === variantId);

        console.log('% cloneVariant() - variantIndex: ' + variantIndex);

        const sourceVariant = this.variants[variantIndex];

        let clonedVariantItems = [];

        angular.forEach(this.variants[variantIndex].items, (variantItem, key) => {
            let clonedVariantItem = Object.assign({}, variantItem);
            clonedVariantItem.id = null;
            clonedVariantItem.configurator_valuation_variant_id = null;
            clonedVariantItem.saved = false;
            clonedVariantItem.hash = null;
            clonedVariantItems.push(clonedVariantItem);
        });

        const clonedVariantIndex = this.variants.length;

        let variant = {
            id: null,
            configurator_valuation_id: this.valuation.id,
            letter_id: this.getVariantLetterId(this.variants.length),
            sort: 999999,
            items: clonedVariantItems,
            shipment_id: sourceVariant.shipment_id,
            shipmentAutoSet: true,
            surcharge_waste: sourceVariant.surcharge_waste,
            discount: sourceVariant.discount,
            loadShipmentMethodsRequests: 0,
            shipmentMethods: [],
            tab_visibility: true,
            saved: false
        };

        this.variants.push(variant);

        this.saveVariant(variant).then(() => {
            this.setClonedVariantFiles(variant).then(() => {
                this.setItemsPreviewContainerId(this.variants[clonedVariantIndex].items);
                this.setItemsMaterials(this.variants[clonedVariantIndex].items);
                this.watchVariantChanges(variant);

                for (let item of this.variants[clonedVariantIndex].items) {
                    item.configurator_valuation_variant_id = variant.id;
                }

                this.$timeout(() => {
                    let itemPromises = [];
                    for (let item of this.variants[clonedVariantIndex].items) {
                        item.saved = false;
                        this.setItemMainShape(item);
                        this.watchItemChanges(item);
                        itemPromises.push(this.saveItem(item));
                    }

                    this.$q.all(itemPromises).then(() => {
                        this.loadShipmentMethods(variant);
                    });
                }, 300);
            });
        });
    }

    setClonedVariantFiles(variant) {
        const deferred = this.$q.defer();
        let productionFilesPromises = [];

        angular.forEach(variant.items, variantItem => {
            if (variantItem.file_name !== null) {
                productionFilesPromises.push(this.$http.get(variantItem.file_name.url).then((response) => {
                    variantItem.file_name.data = response.data;
                }));
            }
        });

        if (productionFilesPromises.length > 0) {
            this.$q.all(productionFilesPromises).then(() => {
                deferred.resolve();
            });
        } else {
            this.$timeout(() => {
                deferred.resolve();
            }, 300);
        }

        return deferred.promise;
    }

    deleteVariant($event, variantId) {
        console.log('% deleteVariant() - variantId: ' + variantId);

        $event.stopPropagation();

        const variantIndex = this.variants.findIndex(x => x.id === variantId);

        console.log('% deleteVariant() - variantIndex: ' + variantIndex);

        this.$http.post(`/admpanel/ajax/configurator/valuations/deleteVariant/${this.valuation.id}/${variantId}`, {
            transformRequest: angular.identity,
            headers: {'Content-Type': undefined}
        }).then(
            (response) => {
                this.variants.splice(variantIndex, 1);

                // Reset variants names
                if (this.variants.length < variantIndex) {
                    return;
                }
                for (let i = 0; i < this.variants.length; i++) {
                    this.variants[i].letter_id = this.getVariantLetterId(i);
                    this.saveVariant(this.variants[i]);
                }
            },
            () => {
                alert(this.translate.t('admpanel.general.unexpectedErrorHasOccurred'));
            }
        );
    }

    watchVariantChanges(variant) {
        this.$scope.$watch(() => [variant.shipment_id, variant.surcharge_waste, variant.discount], (newVal, oldVal) => {
            if (newVal[0] === oldVal[0] && newVal[1] === oldVal[1] && newVal[2] === oldVal[2]) {
                return;
            }

            if (newVal[1] !== oldVal[1] || newVal[2] !== oldVal[2]) {
                this.getItemsPrices(variant.id);
            }

            this.saveVariant(variant);
        }, true);
    }

    getVariantLastOrder(variantIndex) {
        if (this.variants[variantIndex].items.length === 0) {
            return 0;
        }
        let lastOrder = 0;
        for (let item of this.variants[variantIndex].items) {
            if (item.order && parseInt(item.order) > lastOrder) {
                lastOrder = parseInt(item.order);
            }
        }

        return lastOrder;
    }

    addNewItem(variantId) {
        console.log('% addNewItem() - variantId: ' + variantId);

        const variantIndex = this.variants.findIndex(x => x.id === variantId);

        console.log('% addNewItem() - variantIndex: ' + variantIndex);

        const itemIndex = this.variants[variantIndex].items.length;

        let lastOrder = this.getVariantLastOrder(variantIndex);

        this.variants[variantIndex].items.push({
            id: null,
            hash: Math.random().toString(36).replace(/[^a-z]+/g, ''),
            configurator_valuation_id: this.valuation.id,
            configurator_valuation_variant_id: variantId,
            type: null,
            material_id: 1,
            material_subtype_id: 2,
            material_size_id: 3,
            shape: null,
            size_1: null,
            size_2: null,
            size_3: null,
            quantity: 1,
            cut_mode: 'chain',
            cutModeMessageShape: null,
            cutModeMessage: null,
            cut_line: null,
            file_name: null,
            created_at: null,
            activeMaterial: null,
            activeSubType: null,
            activeSize: null,
            new_file_name: null,
            data: null, // data.json
            production_file: null, // data.svg
            price: null,
            unit_price: null,
            saved: false,
            order: ++lastOrder
        });

        console.log('lastOrder', lastOrder);

        this.setItemMaterial(this.variants[variantIndex].items[itemIndex]);

        this.$timeout(() => {
            this.setItemMainShape(this.variants[variantIndex].items[itemIndex]);
            this.watchItemChanges(this.variants[variantIndex].items[itemIndex]);
        }, 300);
    }

    deleteItem(variantId, item, index) {
        console.log('% deleteItem() - variantId: ' + variantId);

        const variantIndex = this.variants.findIndex(x => x.id === variantId);

        console.log('% deleteItem() - variantIndex: ' + variantIndex);

        this.removeItemPriceRequest(item);
        item.loading = true;

        this.$http.post(`/admpanel/ajax/configurator/valuations/deleteItem/${this.valuation.id}/${this.variants[variantIndex].id}/${item.id}`, {
            transformRequest: angular.identity,
            headers: {'Content-Type': undefined}
        }).then(
            (response) => {
                if (response.data.status === 'error') {
                    this.error = response.data.message;
                    item.loading = false;

                    this.$timeout(() => {
                        this.error = false;
                    }, 5000);

                    return;
                }
                this.variants[variantIndex].items.splice(index, 1);
                this.loadShipmentMethods(this.variants[variantIndex]);
            },
            () => {
                item.loading = false;
                alert(this.translate.t('admpanel.general.unexpectedErrorHasOccurred'));
            }
        );
    }

    getItemPrice(item) {
        console.log('% getItemPrice', item.id, this.getItemPriceRequests);

        if (this.getItemPriceRequests.has(item.id)) {
            this.getItemPriceRequests.set(item.id, this.getItemPriceRequests.get(item.id) + 1);
        } else {
            this.getItemPriceRequests.set(item.id, 1);
        }

        item.loading = true;

        const formData = new FormData();

        formData.append('shop_id', JSON.stringify(this.valuation.shop_id)); // tego też już nie potrzebuje na back-end, za to do requesta dodałem sobie this.valuation.id

        this.$http.post(`/admpanel/ajax/configurator/valuations/price/${this.valuation.id}/${item.id}`, formData, {
            transformRequest: angular.identity,
            headers: {'Content-Type': undefined}
        }).then(
            (response) => {
                item.loading = false;
                if (response.data.status === 'error') {
                    this.error = response.data.message;

                    this.$timeout(() => {
                        this.error = false;
                    }, 5000);
                } else {
                    item.price = response.data.price;
                    item.unit_price = response.data.unit_price;
                }
                this.removeItemPriceRequest(item);
            },
            () => {
                this.removeItemPriceRequest(item);
                alert(this.translate.t('admpanel.general.unexpectedErrorHasOccurred'));
            }
        );
    }

    getItemsPrices(variantId) {
        console.log('% getItemsPrices() - variantId: ' + variantId);

        const variantIndex = this.variants.findIndex(x => x.id === variantId);

        console.log('% getItemsPrices() - variantIndex: ' + variantId);

        let delay = 0;

        for (let item of this.variants[variantIndex].items) {
            this.$timeout(() => {
                this.getItemPrice(item);
            }, delay);
            delay += 100;
        }
    }

    removeItemPriceRequest(item) {
        if (!this.getItemPriceRequests.has(item.id)) {
            return;
        }

        let requestsCount = this.getItemPriceRequests.get(item.id);
        if (requestsCount <= 1) {
            this.getItemPriceRequests.delete(item.id);
        } else {
            this.getItemPriceRequests.set(item.id, requestsCount - 1);
        }

        console.log('% reqs', this.getItemPriceRequests);
    }

    getTemplatesStatus() {
        const shop = this.shops.find(x => x.id === this.valuation.shop_id);

        if (typeof(shop) !== 'undefined') {
            return shop.templates_status;
        } else {
            return false;
        }
    }

    getCurrency() {
        return this.shops.find(x => x.id === this.valuation.shop_id).currency;
    }

    getLocale() {
        return this.shops.find(x => x.id === this.valuation.shop_id).locale;
    }

    getTemplate() {
        if (this.valuation.template_id !== null) {
            return this.templates.find(x => x.id === this.valuation.template_id);
        }

        return null;
    }

    getShipmentPrice(variant) {
        let price = 0;

        if (variant.shipment_id !== null && typeof(variant.shipmentMethods) !== 'undefined') {
            let foundedShipmentMethods = variant.shipmentMethods.find(x => x.id === variant.shipment_id);
            if (typeof foundedShipmentMethods !== 'undefined') {
                let valuePrice = String(foundedShipmentMethods.price_net);
                price = parseFloat(valuePrice.replace(',', '.').replace(' ', ''));
            }
        }

        return new Intl.NumberFormat(this.getLocale().replace('_', '-'), {style: 'currency', currency: this.getCurrency().iso_symbol}).format(price);
    }

    getDiscount() {
        let discountValue = 0;

        return new Intl.NumberFormat(this.getLocale().replace('_', '-'), {style: 'currency', currency: this.getCurrency().iso_symbol}).format(discountValue);
    }

    getPrice(variantId, shipment) {
        // console.log('% getPrice() - variantId - ', variantId);

        const variantIndex = this.variants.findIndex(x => x.id === variantId);

        // console.log('% getPrice() - variantIndex - ', variantIndex);

        let valuePrice = 0;
        let price = 0;

        angular.forEach(this.variants[variantIndex].items, (value, key) => {
            if (!value.price) {
                return;
            }

            valuePrice = String(value.price);
            price += parseFloat(valuePrice.replace(',', '.').replace(' ', ''));
        });

        if (shipment && this.variants[variantIndex].shipment_id !== null) {
            let foundedShipmentMethods = this.variants[variantIndex].shipmentMethods.find(x => x.id === this.variants[variantIndex].shipment_id);
            if (typeof foundedShipmentMethods !== 'undefined') {
                valuePrice = String(foundedShipmentMethods.price_net);
                price += parseFloat(valuePrice.replace(',', '.').replace(' ', ''));
            }
        }

        return new Intl.NumberFormat(this.getLocale().replace('_', '-'), {style: 'currency', currency: this.getCurrency().iso_symbol}).format(price);
    }

    changeShop() {
        console.log('% changeShop()');

        this.loadPaymentMethods();

        for (const variant of this.variants) {
            this.loadShipmentMethods(variant);
        }

        Validator.setMaterialsMaxDimensions(this.materials, this.valuation.shop_id);

        angular.forEach(this.variants, variant => {
            angular.forEach(variant.items, (item, key) => {
                this.validateDimensions(item);
            });
        });

        this.templates = [];
        this.sections = [];
        this.valuation.template_id = null;
        this.valuation.template_b2b = 0;
        this.valuation.template_options = {};

        this.loadTemplates();

        this.setPriceGroup(true);

        this.setSurchargeWaste(true);
    }

    changePriceGroup() {
        const priceGroup = this.priceGroups.find(x => x.id === this.valuation.price_group_id);

        for (let variant of this.variants) {
            variant.surcharge_waste = priceGroup.surcharge_waste;
        }
    }

    changeEmail() {
        this.loadUserAddresses();
    }

    loadUserAddresses() {
        this.valuation.payments = {};

        const paymentMethods = this.paymentMethods;
        const valuationPayments = this.valuation.payments;

        this.loading = true;

        this.$http.post(`/admpanel/ajax/users/getUserAddressesByEmail`, {email: this.valuation.email, type: 0}).then(
            (response) => {
                if (response.data.status === 'error') {
                    this.loading = false;
                    this.error = response.data.message;

                    this.$timeout(() => {
                        this.error = false;
                    }, 5000);

                    angular.forEach(paymentMethods, paymentMethod => {
                        if (!paymentMethod.hidden) {
                            valuationPayments[paymentMethod.id] = true;
                        }
                    });
                } else {
                    this.loadUserDiscount(true).then((discount) => {
                        this.defaultDiscount = parseInt(discount);

                        for (let variant of this.variants) {
                            variant.discount = parseInt(discount);
                        }

                        this.showModalForUserAddressSelection(response.data.addresses);
                    }, (errorMessage) => {
                        this.error = errorMessage;

                        this.$timeout(() => {
                            this.error = false;
                        }, 5000);
                    });
                }
            },
            () => {
                alert(this.translate.t('admpanel.general.unexpectedErrorHasOccurred'));
            }
        );
    }

    loadUserHiddenPayments() {
        const deferred = this.$q.defer();

        this.$http.post(`/admpanel/ajax/users/getUserHiddenPaymentsByEmail`, {email: this.valuation.email}).then(
            (response) => {
                this.loading = false;

                if (response.data.status === 'error') {
                    deferred.reject(response.data.message);
                } else {
                    deferred.resolve(response.data.hidden_payments);
                }
            },
            () => {
                alert(this.translate.t('admpanel.general.unexpectedErrorHasOccurred'));
            }
        );

        return deferred.promise;
    }

    showModalForUserAddressSelection(addresses) {
        const shopId = this.valuation.shop_id;

        this.modalService.showModal({
            template: `<div class="modal fade" id="configurator-valuation-adm-modal" tabindex="-1" role="dialog" aria-labelledby="configurator-valuation-adm-modal">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h2 class="modal-title" id="configurator-valuation-adm-modal-label" style="margin: 0;">Wybierz adres użytkownika</h2>
                        </div>
                        <div class="modal-body" style="margin: 20px 0 20px 0;">
                            <select ng-model="$ctrl.selectedAddressId">
                                <option value="" selected="selected">--- {{ $ctrl.getSelectAddressPlaceholder() }} ---</option>
                                <option ng-repeat="address in $ctrl.addresses" value="{{ address.id }}">{{ $ctrl.getSelectAddress(address.id) }}</option>
                            </select>
                        </div>
                        <div class="modal-footer text-right">
                            <input type="button" class="btn btn-default" ng-click="$ctrl.close()" ng-disabled="$ctrl.loading" value="{{ 'admpanel.general.cancel' | t }}" />
                            <input type="button" class="btn btn-default" ng-click="$ctrl.save()" ng-disabled="$ctrl.loading" value="{{ 'admpanel.general.saveData' | t }}" />
                        </div>
                    </div>
                </div>
            </div>`,
            controller: class {
                constructor($scope, addresses, shopId, close) {
                    'ngInject';

                    this.selectedAddressId = null;
                    this.addresses = addresses;
                    this.shopId = shopId;
                    this.closeCallback = close;
                }

                save() {
                    if (this.selectedAddressId === '') {
                        this.closeCallback(null);
                    } else {
                        this.closeCallback(this.getSelectAddress(this.selectedAddressId));
                    }
                }

                close() {
                    this.closeCallback(null);
                }

                getSelectAddressPlaceholder() {
                    return 'wybierz adres';
                }

                getSelectAddress(addressId, show) {
                    const address = this.addresses.find(x => parseInt(x.id) === parseInt(addressId));

                    let addressString = '';

                    if (this.shopId === 2 || this.shopId === 5) {
                        if (address.company === '') {
                            addressString = addressString + address.first_name + ' ' + address.last_name;
                        } else {
                            addressString = addressString + (address.first_name !== '' && address.last_name !== '' ? address.first_name + ' ' + address.last_name + '|' : '') + address.company;
                        }
                    } else {
                        if (address.company === '' && address.tax_id === '') {
                            addressString = addressString + address.first_name + ' ' + address.last_name;
                        } else {
                            addressString = addressString + (address.first_name !== '' && address.last_name !== '' ? address.first_name + ' ' + address.last_name + '|' : '') + address.company;
                        }
                    }

                    addressString = addressString + '|' + address.address;

                    addressString = addressString + '|' + address.zip + ' ' + address.city;

                    return addressString;
                }
            },
            controllerAs: '$ctrl',
            preClose: modal => {
                modal.element.remove();
            },
            inputs: {
                addresses: addresses,
                shopId: shopId
            }
        }).then(modal => {
            modal.close.then(result => {
                if (!result) {
                    return false;
                }

                this.valuation.client_data = result;
            });
        });
    }

    loadUserDiscount(loadUserHiddenPayments) {
        if (loadUserHiddenPayments) {
            this.valuation.payments = {};
        }

        const shopId = this.valuation.shop_id;
        const paymentMethods = this.paymentMethods;
        const valuationPayments = this.valuation.payments;

        const deferred = this.$q.defer();

        this.$http.post(`/admpanel/ajax/users/getUserDiscountByEmail`, {email: this.valuation.email, shop_id: shopId}).then(
            (response) => {
                this.loading = false;

                if (response.data.status === 'error') {
                    deferred.reject(response.data.message);
                } else if (loadUserHiddenPayments) {
                    this.loadUserHiddenPayments().then((hiddenPayments) => {
                        if (hiddenPayments.length > 0) {
                            angular.forEach(hiddenPayments, hiddenPaymentId => {
                                if (paymentMethods.find(payment => payment.id === hiddenPaymentId) !== undefined) {
                                    valuationPayments[hiddenPaymentId] = true;
                                }
                            });
                        } else {
                            angular.forEach(paymentMethods, paymentMethod => {
                                if (!paymentMethod.hidden) {
                                    valuationPayments[paymentMethod.id] = true;
                                }
                            });
                        }
    
                        this.loadUserPriceGroup().then((userPriceGroupData) => {
                            if (userPriceGroupData.price_group_id && userPriceGroupData.surcharge_waste) {
                                this.valuation.price_group_id = userPriceGroupData.price_group_id;

                                for (let variant of this.variants) {
                                    variant.surcharge_waste = userPriceGroupData.surcharge_waste;
                                }
                            }
        
                            deferred.resolve(response.data.discount);
                        }, (errorMessage) => {
                            this.error = errorMessage;
    
                            this.$timeout(() => {
                                this.error = false;
                            }, 5000);
                        });
                    }, (errorMessage) => {
                        this.error = errorMessage;

                        this.$timeout(() => {
                            this.error = false;
                        }, 5000);
                    });
                } else {
                    deferred.resolve(response.data.discount);
                }
            },
            () => {
                alert(this.translate.t('admpanel.general.unexpectedErrorHasOccurred'));
            }
        );

        return deferred.promise;
    }

    loadUserPriceGroup() {
        const deferred = this.$q.defer();

        this.$http.post(`/admpanel/ajax/users/getUserPriceGroup`, {email: this.valuation.email}).then(
            (response) => {
                this.loading = false;

                if (response.data.status === 'error') {
                    deferred.reject(response.data.message);
                } else {
                    deferred.resolve(response.data);
                }
            },
            () => {
                alert(this.translate.t('admpanel.general.unexpectedErrorHasOccurred'));
            }
        );

        return deferred.promise;
    }

    setCurrentDate() {
        this.currentDate = new Date(Date.parse(this.valuation.created_at));

        this.changeOfferValidity();
    }

    changeOfferValidity() {
        this.offerValidityDate = new Date();
        this.offerValidityDate.setDate(this.currentDate.getDate() + parseInt(this.valuation.offer_validity));
    }

    changeMainShapeType(item) {
        item.cutModeMessageShape = null;

        switch (item.shape) {
            case 'Rect':
            default:
                item.cutModeMessageShape = null;
                break;
            case 'RoundedRect':
            case 'Circle':
                item.cutModeMessageShape = 'cięcie leserem, cięcie frezarką';
                break;
        }
    }

    changeCutMode(item) {
        item.cutModeMessage = null;

        switch (item.activeMaterial.name) {
            case 'Plexi bezbarwna': // typy obróbki: cięcie piłą, cięcie piłą + polerowanie, cięcie laserowe, cięcie frezarką
                item.cutModeMessage = null;
                if (item.activeSubType !== null && item.activeSubType.name === 'Bloki') { // typy obróbki: cięcie piłą, cięcie piłą + polerowanie, cięcie frezarką
                    if (item.cut_mode === 'laser') {
                        item.cutModeMessage = 'cięcie piłą, cięcie piłą + polerowanie, cięcie frezarką';
                    }
                }
                break;
            case 'Plexi mleczna': // typy obróbki: cięcie piłą, cięcie piłą + polerowanie, cięcie laserowe, cięcie frezarką
                item.cutModeMessage = null;
                break;
            case 'Plexi czarna': // typy obróbki: cięcie piłą, cięcie piłą + polerowanie, cięcie laserowe, cięcie frezarką
                item.cutModeMessage = null;
                break;
            case 'Plexi biała': // typy obróbki: cięcie piłą, cięcie piłą + polerowanie, cięcie laserowe, cięcie frezarką
                item.cutModeMessage = null;
                break;
            case 'Plexi satynowa': // typy obróbki: cięcie piłą, cięcie piłą + polerowanie, cięcie laserowe, cięcie frezarką
                item.cutModeMessage = null;
                break;
            case 'Poliwęglan lity bezbarwny': // typy obróbki: cięcie piłą, cięcie frezarką
            case 'PET-G bezbarwny':
                if (item.cut_mode === 'chainPolished' || item.cut_mode === 'laser') {
                    item.cutModeMessage = 'cięcie piłą, cięcie frezarką';
                }
                break;
        }

        this.changeDimensions(item);
    }

    changeDimensions(item) {
        // let selectedMaterial = this.materials.find(x => x.id === item.activeMaterial.id);
        // if (item.activeSubType !== null) {
        //     selectedMaterial = selectedMaterial.items.find(x => x.id === item.activeSubType.id)
        // }

        this.validateDimensions(item);

        // const dimensions = selectedMaterial.dimensions[this.valuation.shop_id];

        // item.dimensionsWidthMessage = null;
        // item.dimensionsHeightMessage = null;

        // item.invertedDimensions = false;

        // if (item.size_1 > 0 && dimensions.max_width > 0 && item.size_2 > 0 && dimensions.max_height > 0) {
        //     if ((item.size_1 > dimensions.max_width || item.size_2 > dimensions.max_height) &&
        //         (item.size_1 <= dimensions.max_height && item.size_2 <= dimensions.max_width)) {
        //         item.invertedDimensions = true;
        //     }
        // }

        // if (item.size_1 > 0 && dimensions.max_width > 0 && item.size_1 > dimensions.max_width) {
        //     if((item.size_1 > dimensions.max_width || item.size_2 > dimensions.max_height) &&
        //         (item.size_1 > dimensions.max_height || item.size_2 > dimensions.max_width)) {
        //         item.dimensionsWidthMessage = 'Maksymalny możliwy wymiar wynosi: ' + dimensions.max_width + ' mm.';
        //     }
        // }

        // if (item.size_2 > 0 && dimensions.max_height > 0 && item.size_2 > dimensions.max_height) {
        //     if((item.size_1 > dimensions.max_width || item.size_2 > dimensions.max_height) &&
        //         (item.size_1 > dimensions.max_height || item.size_2 > dimensions.max_width)) {
        //         item.dimensionsHeightMessage = 'Maksymalny możliwy wymiar wynosi: ' + dimensions.max_height + ' mm.';
        //     }
        // }
    }

    validateDimensions(item) {
        item.dimensionsWidthMessage = null;
        item.dimensionsHeightMessage = null;

        let width = item.size_1;
        let height = item.size_2;
        let cutMode = item.cut_mode;

        width = Math.round(width);
        height = Math.round(height);

        const shapeMaxDimm = Validator.getMaxDimensionsForCutMode(cutMode, item.activeMaterial.id, item.activeSubType ? item.activeSubType.id : null)

        /*** Ustalanie warunków walidacji ***/
        let validateMaxDimensions = {
            w: shapeMaxDimm.w,
            h: shapeMaxDimm.h
        }

        /*** Walidacja ***/
        console.log('validateMaxDimensions', validateMaxDimensions, width, height);

        if (width > validateMaxDimensions.w) {
            item.dimensionsWidthMessage = this.translate.t('admpanel.manualConfigurator.maximumPossibleDimensionIs', {size: validateMaxDimensions.w});
        }

        if (height > validateMaxDimensions.h) {
            item.dimensionsHeightMessage = this.translate.t('admpanel.manualConfigurator.maximumPossibleDimensionIs', {size: validateMaxDimensions.h});
        }
    }

    changeTemplate() {
        this.valuation.template_b2b = this.getTemplate().b2b;

        if (this.valuationId === null) {
            if (typeof this.valuation.template_options.sections === 'undefined') {
                this.valuation.template_options = {
                    sections: {}
                };
            }

            this.valuation.template_options.sections[4] = {};

            this.sections[4].forEach((sectionValue) => {
                if (sectionValue.default_value == 1) {
                    this.valuation.template_options.sections[4][sectionValue.id] = true;
                }
            });

            this.valuation.template_options.sections[8] = {};

            this.sections[8].forEach((sectionValue) => {
                if (sectionValue.default_value == 1) {
                    this.valuation.template_options.sections[8][sectionValue.id] = true;
                }
            });
        }
    }

    getItemName(item) {
        const model = item.data;

        model.mainShape.width = item.data.mainShape.oryginalBbox.width.toFixed(0);
        model.mainShape.height = item.data.mainShape.oryginalBbox.height.toFixed(0);

        const materialName = model.material.type.translations[this.getLocale()].name;
        const materialSubTypeName = (model.material.subType ? ', ' + model.material.subType.translations[this.getLocale()].name : '');
        const materialSizeName = model.material.size.translations[this.getLocale()].name;
        const cutModeName = this.cutModes[this.getLocale()][model.cutMode];

        return this.translate.t(
            'configurator.productConfiguratorName',
            {
                'mainShapeName': this.translate.t(`configurator.mainShape.type.${model.mainShape.type.name}`),
                'width': model.mainShape.width,
                'height': model.mainShape.height,
                'materialName': materialName,
                'materialSubTypeName': materialSubTypeName,
                'materialSizeName': materialSizeName,
                'cutModeName': cutModeName,
                'holesCount': 0
            }
        );
    }

    validate() {
        let validationStatus = true;
        let validationMessages = [];

        angular.forEach(this.variants, variant => {
            angular.forEach(variant.items, (item, key) => {
                validationStatus = validationStatus && this.validateItem(item, validationMessages, variant.letter_id, key);
            });
        });

        if (this.getTemplatesStatus() && this.valuation.template_id !== null && this.valuation.template_id > 0) {
            if (this.getTemplate().section_2) {
                if (typeof this.valuation.template_options.sections === 'undefined'
                    || typeof this.valuation.template_options.sections[2] === 'undefined'
                    || typeof this.valuation.template_options.sections[2].text === 'undefined'
                    || this.valuation.template_options.sections[2].text === null
                    || this.valuation.template_options.sections[2].text === '') {
                    validationStatus = false;
                    validationMessages.push('Wybrany szablon oferty wymaga wypełnienia pola sekcji 2.');
                }
            }

            if (this.getTemplate().section_3) {
                if (typeof this.valuation.template_options.sections === 'undefined'
                    || typeof this.valuation.template_options.sections[3] === 'undefined'
                    || typeof this.valuation.template_options.sections[3].text === 'undefined'
                    || this.valuation.template_options.sections[3].text === null
                    || this.valuation.template_options.sections[3].text === '') {
                    validationStatus = false;
                    validationMessages.push('Wybrany szablon oferty wymaga wypełnienia pola sekcji 3.');
                }
            }

            if (this.getTemplate().section_4) {
                if (typeof this.valuation.template_options.sections === 'undefined'
                    || typeof this.valuation.template_options.sections[4] === 'undefined'
                    || Object.values(this.valuation.template_options.sections[4]).filter((val) => val === true).length !== 6) {
                    validationStatus = false;
                    validationMessages.push('Wybrany szablon oferty wymaga wybrania dokładnie 6 pozycji dla sekcji 4.');
                }
            }

            if (this.getTemplate().section_8) {
                if (typeof this.valuation.template_options.sections === 'undefined'
                    || typeof this.valuation.template_options.sections[8] === 'undefined'
                    || Object.values(this.valuation.template_options.sections[8]).filter((val) => val === true).length < 1) {
                    validationStatus = false;
                    validationMessages.push('Wybrany szablon oferty wymaga wybrania minimum 1 pozycji dla sekcji 8.');
                }
            }
        }

        if (this.valuation.shop_id !== 6 && this.loggedAdmin.is_guardian > 0 && (this.valuation.hubspot_deal_id === null || this.valuation.hubspot_deal_id === '')) {
            validationStatus = false;
            validationMessages.push('Administrator opiekun musi uzupełnić pole "ID szansy sprzedaży w HubSpot".');
        }

        if (validationStatus === true) {
            return true;
        }

        this.error = validationMessages.join('\r\n');

        this.$timeout(() => {
            this.error = false;
        }, 5000);

        return false;
    }

    validateItem(item = true, validationMessages = [], variantLetterId, key = 1) {
        console.log('% validateItem', item);
        let validationStatus = true;

        if (item.type === null) {
            validationStatus = false;
            validationMessages.push('Produkt ' + (key + 1) + ' w wariancie ' + variantLetterId +' wymaga wybrania typu.');
        } else if (item.type === 1) {
            if (!item.shape) {
                validationStatus = false;
                validationMessages.push('Produkt ' + (key + 1) + ' w wariancie ' + variantLetterId +' wymaga wybrania kształtu.');
            }

            if (!item.size_1) {
                validationStatus = false;
                validationMessages.push('Produkt ' + (key + 1) + ' w wariancie ' + variantLetterId +' wymaga podania wymiaru W1.');
            }

            if (!item.size_2 && item.shape !== 'Circle') {
                validationStatus = false;
                validationMessages.push('Produkt ' + (key + 1) + ' w wariancie ' + variantLetterId +' wymaga podania wymiaru W2.');
            }

            if (!item.size_3 && item.shape === 'RoundedRect') {
                validationStatus = false;
                validationMessages.push('Produkt ' + (key + 1) + ' w wariancie ' + variantLetterId +' wymaga podania wymiaru W3.');
            }

            if (item.dimensionsWidthMessage) {
                validationStatus = false;
                validationMessages.push('Produkt ' + (key + 1) + ' w wariancie ' + variantLetterId + ': ' + item.dimensionsWidthMessage);
            }

            if (item.dimensionsHeightMessage) {
                validationStatus = false;
                validationMessages.push('Produkt ' + (key + 1) + ' w wariancie ' + variantLetterId + ': ' + item.dimensionsHeightMessage);
            }
        } else if (item.type === 2) {
            if (!item.size_1) {
                validationStatus = false;
                validationMessages.push('Produkt ' + (key + 1) + ' w wariancie ' + variantLetterId +' wymaga podania wymiaru W1.');
            }

            if (!item.size_2) {
                validationStatus = false;
                validationMessages.push('Produkt ' + (key + 1) + ' w wariancie ' + variantLetterId +' wymaga podania wymiaru W2.');
            }

            if (!item.cut_line) {
                validationStatus = false;
                validationMessages.push('Produkt ' + (key + 1) + ' w wariancie ' + variantLetterId +' wymaga podania linii cięcia.');
            }

            if (!(item.file_name !== null || item.new_file_name !== null)) {
                validationStatus = false;
                validationMessages.push('Produkt ' + (key + 1) + ' w wariancie ' + variantLetterId +' wymaga wgrania pliku produkcyjnego.');
            }
        }

        return validationStatus;
    }

    save() {
        if (!this.validate()) {
            return;
        }

        this.loading = true;
        const deferred = this.$q.defer();

        const formData = new FormData();

        formData.append('shop_id', JSON.stringify(this.valuation.shop_id));
        formData.append('price_group_id', JSON.stringify(this.valuation.price_group_id));
        formData.append('client_data', JSON.stringify(this.valuation.client_data));
        formData.append('email', JSON.stringify(this.valuation.email));
        formData.append('offer_validity', JSON.stringify(this.valuation.offer_validity));
        formData.append('payments', JSON.stringify(this.valuation.payments));
        formData.append('template_id', JSON.stringify(this.valuation.template_id));
        formData.append('template_b2b', JSON.stringify(this.valuation.template_b2b));
        formData.append('template_options', JSON.stringify(this.valuation.template_options));
        formData.append('hubspot_deal_id', JSON.stringify(this.valuation.hubspot_deal_id));

        this.$http.post(`/admpanel/ajax/configurator/valuations/save/${this.valuation.id}`, formData, {
            transformRequest: angular.identity,
            headers: {'Content-Type': undefined}
        }).then(
            (response) => {
                this.loading = false;

                if (response.data.status === 'error') {
                    this.error = response.data.message;

                    this.$timeout(() => {
                        this.error = false;
                    }, 5000);
                } else {
                    this.success = response.data.message;

                    this.$timeout(() => {
                        this.success = false;
                    }, 5000);

                    this.valuationId = response.data.valuation_id;
                    this.valuation.id = response.data.valuation_id;
                    this.valuation.number = response.data.valuation_number;

                    this.$location.path('/admpanel/configurator/valuations/edit/' + this.valuation.id, false);

                    this.loadTemplates();

                    for (let variant of this.variants) {
                        this.getItemsPrices(variant.id);
                        this.saveVariant(variant);
                    }

                    deferred.resolve();
                }
            },
            () => {
                alert(this.translate.t('admpanel.general.unexpectedErrorHasOccurred'));
            }
        );

        return deferred.promise;
    }

    purifyVariant(variant) {
        let tmpVariant = Object.assign({}, variant);
        tmpVariant.items = [...tmpVariant.items];

        for (let i in tmpVariant.items) {
            tmpVariant.items[i] = Object.assign({}, tmpVariant.items[i]);
            tmpVariant.items[i].CP = null;
            tmpVariant.items[i].activeMaterial = null;
            tmpVariant.items[i].activeSize = null;
            tmpVariant.items[i].activeSubType = null;
            tmpVariant.items[i].data = null;
            tmpVariant.items[i].production_file = null;
        }

        return tmpVariant;
    }

    saveVariant(variant) {
        const formData = new FormData();
        const deferred = this.$q.defer();
        variant.saved = false;
        variant.saving = true;

        const tmpVariant = this.purifyVariant(variant);

        formData.append('variant', JSON.stringify(tmpVariant));

        this.$http.post(`/admpanel/ajax/configurator/valuations/saveVariant/${this.valuation.id}`, formData, {
            transformRequest: angular.identity,
            headers: {'Content-Type': undefined}
        }).then((response) => {
            variant.saved = true;
            variant.saving = false;
            variant.id = response.data.valuation_variant_id;
            deferred.resolve(response);
        });

        return deferred.promise;
    }

    saveItem(item) {
        console.log('% saveItem()', item);

        const deferred = this.$q.defer();

        let msg = [];

        if (!this.validateItem(item, msg, 'A', 1)) {
            console.log('% saveItem() not validated', msg);
            return false;
        }

        console.log('% saveItem validated??');

        const formData = new FormData();

        item.loading = true;

        const localItem = Object.assign({}, item);

        if (item.new_file_name) {
            formData.append('file', item.new_file_name.fileFormData.get('file'));
        }

        if (item.file_name && item.file_name.data) {
            formData.append('file', new Blob([item.file_name.data]), item.file_name.file.name);
        }

        if (item.type === 1 && item.data && item.data.mainShape) {
            localItem.data = Object.assign({}, localItem.data);

            const oryginalBbox = {
                width: localItem.data.mainShape.oryginalBbox.width,
                height: localItem.data.mainShape.oryginalBbox.height
            };

            const totalLength = localItem.data.mainShape.getLength();
            const name = this.getItemName(localItem);
            const localMainShape = Object.assign({}, localItem.data.mainShape);
            const {...mainShape} = localMainShape;

            localItem.data.material.type.slug = localItem.data.material.type.translations[this.getLocale()].slug;
            localItem.data.material.size.slug = localItem.data.material.size.translations[this.getLocale()].slug;

            if (localItem.data.material.subType) {
                localItem.data.material.subType.slug = localItem.data.material.subType.translations[this.getLocale()].slug;
            }

            mainShape.getLength = function() {
                return this.totalLength;
            };

            mainShape.oryginalBbox = oryginalBbox;
            mainShape.totalLength = totalLength;
            localItem.data.mainShape = mainShape;
            localItem.data.name = name;
        }

        formData.append('item', JSON.stringify(localItem));

        this.$http.post(`/admpanel/ajax/configurator/valuations/saveItem/${this.valuation.id}/${item.configurator_valuation_variant_id}`, formData, {
            transformRequest: angular.identity,
            headers: {'Content-Type': undefined}
        }).then(
            (response) => {
                item.loading = false;
                item.price = response.data.price;
                item.unit_price = response.data.unit_price;
                item.file_name = response.data.file_name;
                item.saved = true;

                if (!item.id) {
                    item.id = response.data.item_id;
                }

                deferred.resolve(item);
            },
            () => {
                item.loading = false;
                alert(this.translate.t('admpanel.general.unexpectedErrorHasOccurred'));
            }
        );

        return deferred.promise;
    }

    canNotifyUser() {
        if (this.valuation.id === null || this.valuation.id === '' || this.valuation.email === null || this.valuation.email === '') {
            return false;
        } else {
            return true;
        }
    }

    notifyUser() {
        this.loading = true;

        this.$http.get(`/admpanel/ajax/configurator/valuations/notifyUser/${this.valuation.id}`).then(
            (response) => {
                this.loading = false;

                if (response.data.status === 'error') {
                    this.error = response.data.message;

                    this.$timeout(() => {
                        this.error = false;
                    }, 5000);
                } else {
                    this.success = response.data.message;

                    this.$timeout(() => {
                        this.success = false;
                    }, 5000);

                    this.valuation.user_notified_at = response.data.valuation.user_notified_at;
                    this.valuation.user_notified_by_admin_id = response.data.valuation.user_notified_by_admin_id;
                    this.valuation.user_notified_admin = response.data.valuation.user_notified_admin;
                }
            },
            () => {
                alert(this.translate.t('admpanel.general.unexpectedErrorHasOccurred'));
            }
        );
    }

    canSendToHubSpot() {
        if (this.loggedAdmin != {} && this.loggedAdmin.is_guardian != 0) { // Jeśli administrator jest opiekunem
            if (this.valuation.hubspot_deal_id === null) {
                return false;
            }
        } else {
            if (this.valuation.hubspot_deal_id !== null) {
                return false;
            }
        }

        if (this.valuation.id === null || this.valuation.id === '' || this.valuation.email === null || this.valuation.email === '' || this.valuation.template_b2b === 0) {
            return false;
        } else {
            return true;
        }
    }

    sendToHubSpot() {
        this.loading = true;

        this.$http.get(`/admpanel/ajax/configurator/valuations/sendToHubSpot/${this.valuation.id}`).then(
            (response) => {
                this.loading = false;

                if (response.data.status === 'error') {
                    this.error = response.data.message;

                    this.$timeout(() => {
                        this.error = false;
                    }, 5000);
                } else {
                    this.success = response.data.message;

                    this.$timeout(() => {
                        this.success = false;
                    }, 5000);

                    this.valuation.hubspot_deal_id = response.data.valuation.hubspot_deal_id;
                    this.valuation.hubspot_notified_at = response.data.valuation.hubspot_notified_at;
                    this.valuation.hubspot_notified_by_admin_id = response.data.valuation.hubspot_notified_by_admin_id;
                    this.valuation.hubspot_admin = response.data.valuation.hubspot_admin;
                }
            },
            () => {
                alert(this.translate.t('admpanel.general.unexpectedErrorHasOccurred'));
            }
        );
    }

    getVariantLetterId(index) {
        if (index <= 25) {
            return String.fromCharCode('A'.charCodeAt() + index);
        } else {
            let prefix = Math.floor(index / 25);
            index = index - (25 * prefix) - 1;

            return String.fromCharCode('A'.charCodeAt() + index) + prefix;
        }
    }

    toggleVariantTab(variant) {
        variant.tab_visibility = !variant.tab_visibility;

        if (!variant.items_loaded) {
            this.loadItems(variant.id)
        }
    }

    variantUpDisabled(variant) {
        return this.variants.indexOf(variant) === 0;
    }

    variantDownDisabled(variant) {
        return this.variants.indexOf(variant) === this.variants.length - 1;
    }

    variantUp($event, variant) {
        console.log('% variantUp');
        this.variantMove($event, variant, -1, this.variantUpDisabled(variant));
    }

    variantDown($event, variant) {
        console.log('% variantDown');
        this.variantMove($event, variant, 1, this.variantDownDisabled(variant));
    }

    variantMove($event, variant, direction, disabled) {
        console.log('% variantMove');

        $event.stopPropagation();

        if (disabled) {
            return false;
        }

        const variantIndex = this.variants.indexOf(variant);
        const previousVariant = this.variants[variantIndex + direction];

        this.variants[variantIndex] = null;
        this.variants[variantIndex + direction] = variant;
        this.variants[variantIndex] = previousVariant;

        for (const [index, variant] of this.variants.entries()) {
            variant.saving = true;
            variant.saved = false;
            variant.sort = index;
            variant.letter_id = this.getVariantLetterId(index);
        }

        let tmpVariants = [...this.variants];

        for(let i = 0; i < tmpVariants.length; i++) {
            tmpVariants[i] = this.purifyVariant(tmpVariants[i]);
        }

        const formData = new FormData();
        formData.append('variants', JSON.stringify(tmpVariants));

        this.$http.post(`/admpanel/ajax/configurator/valuations/saveVariants/${this.valuation.id}`, formData, {
            transformRequest: angular.identity,
            headers: {'Content-Type': undefined}
        }).then(
            (response) => {
                if (response.data.status === 'error') {
                    this.error = response.data.message;

                    this.$timeout(() => {
                        this.error = false;
                    }, 5000);
                } else {
                    for (const variant of this.variants) {
                        variant.saved = true;
                        variant.saving = false;
                    }
                }
            },
            () => {
                alert(this.translate.t('admpanel.general.unexpectedErrorHasOccurred'));
            }
        );
    }

    canAddNewVariant() {
        for (const variant of this.variants) {
            if (variant.items.length === 0) {
                return false;
            }
        }

        return true;
    }
}

let configuratorValuationAdmComponent = {
    bindings: {
        'valuationId': '<'
    },
    template: configuratorValuationAdmHtml,
    controller: configuratorValuationAdmController
};

export default configuratorValuationAdmComponent;
